import { useLocation } from "react-router-dom";

export const useBotPageFlags = () => {
  const { pathname } = useLocation();

  return {
    isDashboard: pathname.startsWith("/dashboard"),
    isPortfolio: pathname.startsWith("/portfolio"),
    isBotPage: pathname.startsWith("/bot"),
  };
};
